import styled from 'styled-components';
import { Link } from 'edenred-ui';

export const UnstyledLink = styled(Link)`
  &:active,
  &:focus,
  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;
